import { div } from 'react';
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const RouteSheetHeader = ({
  objectName,
  plateNumber,
  startTime,
  endTime,
  mileageStart,
  mileageEnd,
  totalWorkHours,
  totalRestHours,
  totalDistance,
}) => {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <span>
        <i>GTT 07 EOOD</i>
      </span>
      <div className={clsx(styles.flexRow, styles.pv4)}>
        <div className={clsx(styles.flexGrow1)}></div>
        <div className={clsx(styles.inputField, styles.flexGrow1)}>
          <div className={clsx(styles.label, styles.lineHeight1)}>
            <span>Разрешил излизането: </span>
          </div>
          <div className={clsx(styles.flexGrow1)}>
            <div className={clsx(styles.elipsis, styles.lineHeight1)}></div>
            <div className={styles.placeholder}>
              <span>подпис, печат</span>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.divider}></div>
      <div className={styles.headerText}>
        <span>ПЪТЕН ЛИСТ</span>
      </div>
      <div className={clsx(styles.flexRow, styles.pv4)}>
        <div
          className={clsx(
            styles.lineHeight1,
            styles.flexGrow1,
            styles.boldText,
          )}
        >
          <span>Автомобил: {objectName}</span>
        </div>
        <div
          className={clsx(
            styles.lineHeight1,
            styles.flexGrow1,
            styles.boldText,
          )}
        >
          <span>Регистрационен номер:</span>
          <span>{plateNumber}</span>
        </div>
      </div>
      <div className={clsx(styles.flexRow, styles.pv2)}>
        <div>
          <div className={styles.lineHeight1}>
            <span>Водач I смяна</span>
          </div>
          <div className={styles.lineHeight1}>
            <span>Водач II смяна</span>
          </div>
          <div className={styles.lineHeight1}>
            <span>Издал пътния лист</span>
          </div>
        </div>
        <div className={styles.flexGrow2}>
          <div className={styles.elipsis}></div>
          <div className={styles.elipsis}></div>
          <div className={styles.flexGrow1}>
            <div className={styles.elipsis}></div>
            <div className={styles.placeholder}>
              <span>име, фамилия</span>
            </div>
          </div>
        </div>
        <div className={styles.flexGrow1}>
          <div className={styles.flexRow}>
            <div className={clsx(styles.flexGrow1, styles.flexRow)}>
              <span>от</span>
              <div className={clsx(styles.elipsis, styles.flexGrow1)}></div>
            </div>
            <div className={clsx(styles.flexGrow1, styles.flexRow)}>
              <span>до</span>
              <div className={clsx(styles.elipsis, styles.flexGrow1)}></div>
            </div>
          </div>
          <div className={styles.flexRow}>
            <div className={clsx(styles.flexGrow1, styles.flexRow)}>
              <span>от</span>
              <div className={clsx(styles.elipsis, styles.flexGrow1)}></div>
            </div>
            <div className={clsx(styles.flexGrow1, styles.flexRow)}>
              <span>до</span>
              <div className={clsx(styles.elipsis, styles.flexGrow1)}></div>
            </div>
          </div>
          <div className={styles.flexRow}>
            <div className={clsx(styles.flexGrow1)}>
              <div className={clsx(styles.elipsis, styles.flexGrow1)}></div>
              <div className={styles.placeholder}>
                <span>дата</span>
              </div>
            </div>
            <div className={styles.flexGrow1}>
              <div className={clsx(styles.elipsis, styles.flexGrow1)}></div>
              <div className={styles.placeholder}>
                <span>подпис</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={clsx(
          styles.flexGrow2,
          // styles.flexRow,
          // styles.lineHeight3,
          styles.pv2,
        )}
      >
        <div className={clsx(styles.flexGrow1, styles.boldText)}>
          <span>Начало на работа: </span>
          <span>{startTime}</span>
        </div>
        <div className={clsx(styles.flexGrow1, styles.boldText)}>
          <span>Край на работа: </span>
          <span>{endTime}</span>
        </div>
      </div>
      <div className={clsx(styles.flexRow, styles.pv1)}>
        <div className={clsx(styles.border2, styles.flexGrow1, styles.p1)}>
          <div className={styles.pv4}>
            <span>Автомобилът е технически изправен</span>
          </div>
          <div className={clsx(styles.flexRow, styles.flexGrow1)}>
            <div className={clsx(styles.inputField, styles.flexGrow3)}>
              <div className={clsx(styles.label, styles.lineHeight1)}>
                <span>Механик: </span>
              </div>
              <div className={styles.flexGrow1}>
                <div className={clsx(styles.elipsis, styles.lineHeight1)}></div>
                <div className={styles.placeholder}>
                  <span>фамилия</span>
                </div>
              </div>
            </div>
            <div className={styles.flexGrow1}>
              <div className={clsx(styles.elipsis, styles.lineHeight1)}></div>
              <div className={styles.placeholder}>
                <span>подпис</span>
              </div>
            </div>
          </div>
        </div>
        <div className={clsx(styles.border2, styles.flexGrow1, styles.p1)}>
          <div className={styles.pv4}>
            <span>Приех автомобила технически изправен</span>
          </div>
          <div className={styles.flexRow}>
            <div className={clsx(styles.inputField, styles.flexGrow3)}>
              <div className={clsx(styles.label, styles.lineHeight1)}>
                <span>Водач: </span>
              </div>
              <div className={styles.flexGrow1}>
                <div className={clsx(styles.elipsis, styles.lineHeight1)}></div>
                <div className={styles.placeholder}>
                  <span>фамилия</span>
                </div>
              </div>
            </div>
            <div className={clsx(styles.flexGrow1)}>
              <div className={clsx(styles.elipsis, styles.lineHeight1)}></div>
              <div className={styles.placeholder}>
                <span>подпис</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.pv2}>
        <div className={clsx(styles.border2, styles.flexRow)}>
          <div className={clsx(styles.flexGrow1, styles.p1, styles.pv4)}>
            <div className={styles.flexRow}>
              <div className={clsx(styles.inputField, styles.flexGrow3)}>
                <div className={clsx(styles.label, styles.lineHeight1)}>
                  <span>Проба за алкохол: </span>
                </div>
                <div className={styles.flexGrow1}>
                  <div
                    className={clsx(styles.elipsis, styles.lineHeight1)}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div className={clsx(styles.flexGrow1, styles.p1)}>
            <div className={styles.pv4}>
              <span>Водачът е годен да управлява. Извършил проверката: </span>
            </div>
            <div className={styles.flexRow}>
              <div className={clsx(styles.inputField, styles.flexGrow3)}>
                <div className={styles.flexGrow1}>
                  <div
                    className={clsx(styles.elipsis, styles.lineHeight1)}
                  ></div>
                  <div className={styles.placeholder}>
                    <span>фамилия</span>
                  </div>
                </div>
              </div>
              <div className={styles.flexGrow1}>
                <div className={clsx(styles.elipsis, styles.lineHeight1)}></div>
                <div className={styles.placeholder}>
                  <span>подпис</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={clsx(styles.border2, styles.flexRow)}>
          <div className={clsx(styles.flexGrow1, styles.p1)}>
            <div className={clsx(styles.flexRow, styles.pv4)}>
              <div className={clsx(styles.inputField, styles.flexGrow3)}>
                <div className={clsx(styles.label, styles.lineHeight1)}>
                  <span>Общо здравословно състояние: </span>
                </div>
                <div className={styles.flexGrow1}>
                  <div
                    className={clsx(styles.elipsis, styles.lineHeight1)}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div className={clsx(styles.flexGrow1, styles.p1)}>
            <div className={styles.pv4}>
              <span>Извършил проверката: Медицинско лице </span>
            </div>
            <div className={styles.flexRow}>
              <div className={clsx(styles.inputField, styles.flexGrow3)}>
                <div className={styles.flexGrow1}>
                  <div
                    className={clsx(styles.elipsis, styles.lineHeight1)}
                  ></div>
                  <div className={styles.placeholder}>
                    <span>фамилия</span>
                  </div>
                </div>
              </div>
              <div className={styles.flexGrow1}>
                <div className={clsx(styles.elipsis, styles.lineHeight1)}></div>
                <div className={styles.placeholder}>
                  <span>подпис</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={clsx(styles.flexRow, styles.pv1)}>
        <div className={clsx(styles.border2, styles.flexGrow1, styles.p1)}>
          <div className={styles.pv4}>
            <span>Автомобилът приех:</span>
          </div>
          <div className={styles.flexRow}>
            <div className={clsx(styles.inputField, styles.flexGrow3)}>
              <div className={clsx(styles.label, styles.lineHeight1)}>
                <span>Механик: </span>
              </div>
              <div className={styles.flexGrow1}>
                <div className={clsx(styles.elipsis, styles.lineHeight1)}></div>
                <div className={styles.placeholder}>
                  <span>фамилия</span>
                </div>
              </div>
            </div>
            <div className={styles.flexGrow1}>
              <div className={clsx(styles.elipsis, styles.lineHeight1)}></div>
              <div className={styles.placeholder}>
                <span>подпис</span>
              </div>
            </div>
          </div>
        </div>
        <div className={clsx(styles.border2, styles.flexGrow1, styles.p1)}>
          <div className={styles.pv4}>
            <span>Автомобилът предадох</span>
          </div>
          <div className={styles.flexRow}>
            <div className={clsx(styles.inputField, styles.flexGrow3)}>
              <div className={clsx(styles.label, styles.lineHeight1)}>
                <span>Водач: </span>
              </div>
              <div className={styles.flexGrow1}>
                <div className={clsx(styles.elipsis, styles.lineHeight1)}></div>
                <div className={styles.placeholder}>
                  <span>фамилия</span>
                </div>
              </div>
            </div>
            <div className={styles.flexGrow1}>
              <div className={clsx(styles.elipsis, styles.lineHeight1)}></div>
              <div className={styles.placeholder}>
                <span>подпис</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.pv2}>
        <div className={clsx(styles.border2, styles.flexGrow1)}>
          <div className={clsx(styles.flexRow, styles.p1)}>
            <div className={styles.flexGrow1}>
              <span>Километраж начало: {mileageStart}</span>
            </div>
            <div className={styles.flexGrow1}>
              <span>Километраж край: {mileageEnd}</span>
            </div>
          </div>
          <div className={clsx(styles.flexRow, styles.p1)}>
            <div className={styles.flexGrow1}>
              <span>Часове почивка: {totalRestHours}</span>
            </div>
            <div className={styles.flexGrow1}>
              <span>Часове работа: {totalWorkHours}</span>
            </div>
          </div>
          <div className={styles.p1}>
            <span>Изминат път: {totalDistance} (км)</span>
          </div>
        </div>
      </div>
      <div className={styles.pv2}>
        <div
          className={clsx(
            styles.border2,
            styles.flexGrow1,
            styles.p1,
            styles.pv3,
            styles.notes,
          )}
        >
          <span>Бележки на водача:</span>
        </div>
      </div>
    </div>
  );
};

RouteSheetHeader.propTypes = {
  objectName: PropTypes.string,
  plateNumber: PropTypes.string,
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  mileageStart: PropTypes.number,
  mileageEnd: PropTypes.number,
  totalWorkHours: PropTypes.string,
  totalRestHours: PropTypes.string,
  totalDistance: PropTypes.number,
};

const useStyles = makeStyles(() => ({
  container: {
    '& span': {
      fontSize: '15px',
    },
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  p1: {
    padding: '4px',
  },
  pv1: {
    paddingTop: '4px',
    paddingBottom: '4px',
  },
  pv2: {
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  pv3: {
    paddingTop: '12px',
    paddingBottom: '12px',
  },
  pv4: {
    paddingTop: '16px',
    paddingBottom: '16px',
  },
  flexGrow1: {
    flex: 1,
  },
  flexGrow2: {
    flex: 2,
  },
  flexGrow3: {
    flex: 3,
  },
  inputField: {
    display: 'flex',
    flexDirection: 'row',
  },
  label: {
    fontSize: '15px',
  },
  lineHeight1: {
    height: '20px',
    lineHeight: '20px',
  },
  lineHeight3: {
    height: '28px',
    lineHeight: '28px',
  },
  elipsis: {
    height: '17px',
    borderBottomWidth: 2,
    borderBottomColor: 'grey',
    borderBottomStyle: 'dotted',
    marginLeft: '8px',
    marginRight: '8px',
  },
  placeholder: {
    textAlign: 'center',
    '& span': {
      fontSize: '15px',
      fontStyle: 'italic',
    },
  },
  divider: {
    width: '100%',
    height: '2px',
    backgroundColor: 'grey',
  },
  headerText: {
    width: '100%',
    textAlign: 'center',
    '& span': {
      backgroundColor: 'grey',
      color: 'white',
      letterSpacing: 10,
      fontSize: 30,
    },
  },
  boldText: {
    '& span': {
      fontWeight: 'bold',
    },
  },
  border2: {
    borderWidth: 2,
    borderColor: 'grey',
    borderStyle: 'solid',
  },
  notes: {
    height: '100px',
    breakInside: 'avoid',
  },
}));

export default RouteSheetHeader;
